export default __webpack_public_path__ + "static/media/2021_Chang_et_el_2021_EcologyLetters.f9be58a0.pdf";